export function closeAllElements(store) {
    const { menuState, stateEditableItem, stateDueDate, stateCombo } = store.getState();
    menuState &&
        store.in.exec("close-menu", {
            ...menuState,
        });
    stateEditableItem &&
        store.in.exec("close-inline-editor", {
            id: stateEditableItem.id,
            save: true,
        });
    stateDueDate?.open &&
        store.in.exec("set-state-due-date", {
            ...stateDueDate,
            open: false,
        });
    stateCombo?.open &&
        store.in.exec("set-state-due-date", {
            ...stateDueDate,
            open: false,
        });
}
//# sourceMappingURL=common.js.map